import { customAxios } from "./customAxios";

/**
 * CCTV 전체 목록
 * @returns 
 */
export const getCctvsAll = async()=>{
  const res = await customAxios.get('/api/cctvs');
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 활성화된 CCTV 목록
 * @returns 
 */
export const getCctvsActive = async()=>{
  const res = await customAxios.get('/api/cctvs/active');
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * CCTV 상세
 * @param {*} query 
 * @returns 
 */
export const getCctvByQuery = async(id)=>{
  const res = await customAxios.get('/api/cctvs/'+id);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * CCTV 등록
 * @param {*} body 
 */
export const postCctv = async(body)=>{
  await customAxios.post('/api/cctvs',body);
}

/**
 * CCTV 삭제
 * @param {*} param 
 */
export const deleteCctv = async(id)=>{
  await customAxios.delete('/api/cctvs/'+id);
}
